import { createReducer } from '@reduxjs/toolkit';
import {
    SET_MUSIC_DATA,
    ADD_MUSIC_DATA,
    SET_IS_LOADING_MUSICS_PAGE,
    SET_FILTERED_MUSIC_DATA,
    ADD_FILTERED_MUSIC_DATA,
    SET_NO_MORE_MUSICS,
    SET_NO_MORE_FILTERED_MUSICS,
    SET_LAST_FILTER_QUERY,
} from '../actions/MusicsPageActions';

const initialState = {
    musicsPageData: [],
    filteredMusics: [],
    isLoading: false,
    noMoreMusics: false,
    noMoreFilteredMusics: false,
    lastFilterQuery: '',
};

// @TODO create an ADD_MUSIC as this and SET are two different things.
// The SET_MUSIC can be a reset too when applying filters.
// currently we (re)set the playlist on every play click on any music item

const musics = createReducer(initialState, (builder) => {
    builder
        .addCase(SET_MUSIC_DATA, (state, action) => {
            state.musicsPageData = action.data;
        })
        .addCase(ADD_MUSIC_DATA, (state, action) => {
            state.musicsPageData = state.musicsPageData.concat(action.data);
        })
        .addCase(SET_FILTERED_MUSIC_DATA, (state, action) => {
            state.filteredMusics = action.data;
        })
        .addCase(ADD_FILTERED_MUSIC_DATA, (state, action) => {
            state.filteredMusics = state.filteredMusics.concat(action.data);
        })
        .addCase(SET_IS_LOADING_MUSICS_PAGE, (state, action) => {
            state.isLoading = action.isLoading;
        })
        .addCase(SET_NO_MORE_MUSICS, (state, action) => {
            state.noMoreMusics = action.data;
        })
        .addCase(SET_NO_MORE_FILTERED_MUSICS, (state, action) => {
            state.noMoreFilteredMusics = action.data;
        })
        .addCase(SET_LAST_FILTER_QUERY, (state, action) => {
            state.lastFilterQuery = action.data;
        });
});

export default musics;
